import one360 from './one360';
import type { ProjektdokumentationFormData, ProjektdokumentationStatusUpdate, ProjektdokumentationTemplate } from '../../types/projektdokumentation';

export const getProjektdokumentationTemplate = async (
  projectId: string
): Promise<ProjektdokumentationTemplate> =>
  one360.get(`/api/v1/ops/projects/${encodeURIComponent(projectId)}/projektdokumentation-template`);

export const upsertProjektdokumentation = async (
  projectId: string,
  payload: ProjektdokumentationFormData
) =>
  one360.put(`/api/v1/ops/projects/${encodeURIComponent(projectId)}/projektdokumentation`, payload);

export const updateProjektdokumentationStatus = async (
  projectId: string,
  payload: ProjektdokumentationStatusUpdate
) =>
  one360.post(`/api/v1/ops/projects/${encodeURIComponent(projectId)}/projektdokumentation/status`, payload);
